<div id = "page-not-found-container">
    <div id = "page-not-found-text">
        Hey.<br />
        Tudom véletlen keveredtél ide, de itt nincs semmi látnivaló.
    </div>
</div>